import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  DurationSchemaWithMax,
  DurationUnits,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';
import { BlockValueEmailSchema } from '../base/blockValueEmailSchema.js';

export const SendEmailConfigSchema = z.object({
  senderEmail: BlockValueEmailSchema({ isRequired: true }),
  senderName: z.string().min(1, 'This field is required.'),
  recipientEmail: BlockValueEmailSchema({ isRequired: true }),
  subject: z.string().min(1, 'This field is required.'),
  content: z.string().min(1, 'This field is required.'),
  timeout: DurationSchemaWithMax('timeout', {
    value: 1,
    units: DurationUnits.Hours,
  }),
});

export type SendEmailConfig = z.infer<typeof SendEmailConfigSchema>;

export interface SendEmailBlockOutput {
  statusCode: number;
  body: any;
  message?: string;
}

export const SendEmailBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.SendEmail),
  config: SendEmailConfigSchema,
  returnType: returnTypeSchema(ProducedType.SendEmail),
});
export type SendEmailBlock = z.infer<typeof SendEmailBlockSchema>;
